import { useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SECTIONS = ["services", "manifesto", "founder", "casestudy", "contact"];

const getVisitorId = () => {
  let id = localStorage.getItem("ate_visitor_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `v-${Date.now()}-${Math.random()}`;
    localStorage.setItem("ate_visitor_id", id);
  }
  return id;
};

const post = (body) =>
  fetch(`${API}/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});

export const useTracking = () => {
  useEffect(() => {
    const visitor_id = getVisitorId();
    post({ visitor_id, type: "pageview", referrer: document.referrer || "" });

    const seen = new Set();
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !seen.has(e.target.id)) {
            seen.add(e.target.id);
            post({ visitor_id, type: "section", name: e.target.id });
          }
        });
      },
      { threshold: 0.4 }
    );
    SECTIONS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, []);
};

export default useTracking;
